import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-mapa-infra-social',
  templateUrl: './mapa-infra-social.component.html',
  styleUrls: ['./mapa-infra-social.component.scss']
})
export class MapaInfraSocialComponent implements OnInit {
  map: any;
  layerGroup: any;
  layerGroupShapes: any;

  @Input() sedes: any;

  @ViewChild('primaryMap', {static: true}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  constructor() { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;
  }

  ngAfterViewInit() {
    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    this.map = L.map('map', { scrollWheelZoom: false }).setView([19.369903, -99.148074], 12);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    this.layerGroup = L.layerGroup().addTo(this.map);
    this.layerGroupShapes = L.layerGroup().addTo(this.map);

    this.buildMap(this.sedes.filters);
  }

  private buildMap (sedes) {
    let iconMarker = L.icon({
      iconUrl: 'assets/images/marker-icon.png'
    })
    sedes.map(async (el) => {
      let LatLong = Object.prototype.toString.call(el.geom_point) == "[object String]" ? el.geom_point.split(",") : el.geom_point;
      let MarkerOptions = {
		    radius: 8,
		    fillColor: "#ff7800",
		    color: "#000",
		    weight: 1,
		    opacity: 1,
		    fillOpacity: 0.8,
        border: 0,
        icon: iconMarker,
        outline: 0
			};

      if (LatLong.length > 1) {
        L.marker(LatLong, MarkerOptions)
          .bindPopup(`
            <div>
              <h3><b>${el.nombre}</b></h3>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Responsable:</b> ${el.responsable} - ${el.unidad_responsable}</p>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Unidad responsable:</b> ${el.desc_unidad_responsable}</p>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Alcaldía:</b> ${el.alcaldia}</p>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Actividades:</b> ${el.actividades}</p>
              <p class="mt-0 mb-0 text-wrap" style="font-size: 14px !important;"><b>Domicilio:</b><br> ${el.calle} ${el.numero_exterior} ${el.numero_interior}, ${el.manzana} ${el.lote}, ${el.colonia}</p>
              <p class="mt-0 mb-0 text-wrap" style="font-size: 14px !important;"><b>Días apertura:</b> ${el.dias_apertura}</p>
              <p class="mt-0 mb-0 text-wrap" style="font-size: 14px !important;"><b>Teléfono:</b> ${el.telefono}</p>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Perfil población:</b> ${el.perfil_poblacion}</p>
              <p class="mt-0 mb-0" style="font-size: 14px !important;"><b>Tipo de servicio:</b> ${el.tipo_servicio}</p>
            </div>
          `)
          .addTo(this.layerGroup);
      }
    });
  }

}
